// Web Config
export const UPDATE_CONFIG = "UPDATE_CONFIG";

// User
export const UPDATE_USER = "UPDATE_USER";

// Login Page
export const UPDATE_ERROR_MSG = "UPDATE_ERROR_MSG";


// WEBPACK FOOTER //
// ./src/actionTypes.js